import { TextField } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import * as facilityGroupFormLocalState from '../../_state/facilityGroupForm.localState';

import { FacilitySelect } from './FacilitySelect';

import { useTranslations } from '@/facilities/i18n/useTranslations';

type FacilityGroupFormProps = {
  isEditing?: boolean;
};

export const FacilityGroupForm = (_props: FacilityGroupFormProps) => {
  const t = useTranslations();
  const form = useAtomValue(facilityGroupFormLocalState.$facilityGroupForm);
  const updateForm = useSetAtom(
    facilityGroupFormLocalState.$updateFacilityGroupForm,
  );

  const handleFieldChange =
    <K extends keyof typeof form>(field: K) =>
    (value: (typeof form)[K]) => {
      updateForm({
        [field]: value,
      });
    };

  return (
    <div className="@FacilityGroupForm flex flex-col gap-4">
      <TextField
        label={t.facilityGroups.dialog.form.name.label}
        value={form.name}
        onChange={handleFieldChange('name')}
        isRequired
      />

      <FacilitySelect
        label={t.facilityGroups.dialog.form.facilities.label}
        values={form.facilityIds}
        onChange={handleFieldChange('facilityIds')}
      />
    </div>
  );
};
